module.exports = __webpack_public_path__ + "media/adjust-specifications.d3b69c87.mp4";